import React from 'react';
import './App.css';
import Slot from './components/Slot';

function App() {
  return (
    <div className="App">
      <Slot />
    </div>
  );
}

export default App;
